import analysis from './analysis';
// 企业信息
import information from './information';
// 员工权限
import permission from './permission';
// 安全控制
import safe from './safe';
// 第三方账号
import thirdAccount from './third_account';
// 个人资料
import accountInfo from './account_info';
// 系统管理
import systemManager from './system_manager';
// 员工权限
import staffPriv from './staff_priv';
// 下载中心
import download  from './download';
// 找回密码
import findPsw from './find_psw';
// 员工服务
import wework from './wework';
export default [
  ...analysis,
  ...information,
  ...permission,
  ...safe,
  ...thirdAccount,
  ...accountInfo,
  ...systemManager,
  ...staffPriv,
  ...download,
  ...findPsw,
  ...wework,
];
